import { useAuth } from "@/contexts/AuthContext";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import AppShell from "@/components/AppShell";
import BuyerSidebar from "@/components/BuyerSidebar";
import BuyerBottomNav from "@/components/BuyerBottomNav";
import { ADMIN_ROLES } from "@/lib/roles";

/**
 * App shell for buyer pages: the shared sidebar layout. Admins (who can also
 * reach buyer routes) keep the original layout with just navigation + content +
 * footer and no sidebar.
 */
export default function BuyerShell({ children }: { children: React.ReactNode }) {
  const { hasRole } = useAuth();
  const showSidebar = hasRole("buyer") && !hasRole(...ADMIN_ROLES);

  if (!showSidebar) {
    return (
      <>
        <Navigation />
        {children}
        <Footer />
      </>
    );
  }

  // The mobile tab bar sits inside AppShell so "More" can reach its drawer.
  return (
    <AppShell sidebar={<BuyerSidebar />}>
      {children}
      <BuyerBottomNav />
    </AppShell>
  );
}
